import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var _templateObject, _templateObject2;
const MIN_GRID_ITEM_WIDTH = '200px';

/**
 * Two simple grids - flexbox and css grid based
 * All children are equal, unless you specify otherwise with your own styles.
 *
 * @example
 * <FlexGrid>
 *  <div css={`flex-basis: 50%;`}>50%</div>
 *  <div>1/3 of remaining space</div>
 * </FlexGrid>
 *
 * @see https://smolcss.dev/#smol-css-grid
 * @see https://smolcss.dev/#smol-flexbox-grid
 **/
const FlexGridWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "grid__FlexGridWrapper",
  componentId: "sc-f60lst-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: ", ";\n  gap: ", ";\n  width: 100%;\n\n  > * {\n    flex: ", ";\n  }\n"])), _ref => {
  let {
    wrap
  } = _ref;
  return wrap && 'wrap';
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing.doubleSpacing;
}, _ref3 => {
  let {
    minItemWidth
  } = _ref3;
  return "1 1 ".concat(minItemWidth);
});
const FlexGrid = /*#__PURE__*/forwardRef(function FlexGrid(_ref4, ref) {
  let {
    children,
    minItemWidth = MIN_GRID_ITEM_WIDTH,
    wrap = true,
    ...rest
  } = _ref4;
  return /*#__PURE__*/jsx(FlexGridWrapper, {
    minItemWidth: minItemWidth,
    wrap: wrap,
    ref: ref,
    ...rest,
    children: children
  });
});
const GridWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "grid__GridWrapper",
  componentId: "sc-f60lst-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: ", ";\n  gap: ", ";\n  width: 100%;\n"])), _ref5 => {
  let {
    minItemWidth
  } = _ref5;
  return "repeat(auto-fit, minmax(".concat(minItemWidth, ", 1fr))");
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing.doubleSpacing;
});
const Grid = /*#__PURE__*/forwardRef(function Grid(_ref7, ref) {
  let {
    children,
    minItemWidth = MIN_GRID_ITEM_WIDTH,
    ...rest
  } = _ref7;
  return /*#__PURE__*/jsx(GridWrapper, {
    ref: ref,
    ...rest,
    minItemWidth: minItemWidth,
    children: children
  });
});

export { FlexGrid, Grid };
